import { Component, ElementRef, EventEmitter, Input, isDevMode, OnInit, Output, ViewChild} from "@angular/core";
import { SlickDialogComponent } from "slick-components";
import { IVersionReleaseModel } from "@models/version-release/version-release.model";

import { GlobalsService, HttpService } from "@services"

@Component({
    selector: "version-release-dialog",
    templateUrl: "./version-release-dialog.component.html",
    styleUrl: "./version-release-dialog.component.css",
    standalone: false
})
export class VersionReleaseDialogComponent {
	@ViewChild('dialogElement', { static: false }) dialogElement: ElementRef; // Reference to the dialog element
	@Input() isMobile: boolean = false;
	@Input() versionModels: IVersionReleaseModel[];

	@Input() isOpen = false;

	@Output() onClose = new EventEmitter<void>();
	loading: boolean = false;

	constructor(private readonly httpService: HttpService) {
	}

	async showLastFiveVersions() {
		this.loading = true;
		this.versionModels = [];
		this.versionModels = await this.httpService.get("/versionRelease/GetLastFiveVersionReleases");
		this.loading = false;
    }

	close() {
		this.onClose.emit();
	}
}
